import React from "react";
import PlayIcon from "../icons/Play";
import styled from "styled-components";
import tw from "tailwind.macro";

const VideoButton = styled.button.attrs(({ className }) => ({
  className: `flex items-center justify-center bg-white rounded-full z-20 ${className}`,
}))`
  width: 2.813rem;
  height: 2.813rem;
  ${({ hidden }) => hidden && tw`hidden`}
`;

const PlayPauseButton = ({
  onClick = () => {},
  className = "",
  hidden,
  paused,
  ...rest
}) => (
  <VideoButton
    onClick={onClick}
    className={className}
    hidden={hidden}
    aria-label={paused ? "Play the video" : "Pause the video"}
    {...rest}
  >
    {paused ? (
      <PlayIcon className="w-4 h-4 text-action-blue" />
    ) : (
      <div className="flex">
        <span className="h-4 w-1 bg-action-blue mr-1"></span>
        <span className="h-4 w-1 bg-action-blue"></span>
      </div>
    )}
  </VideoButton>
);

export default PlayPauseButton;
